import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import "@/style/mapbox-gl.css";
import "bulma/css/bulma.css";
import vuetify from './plugins/vuetify';
import router from './router';
import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
  id: 'UA-144474235-3',
  router,
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");